module.exports = __webpack_public_path__ + "static/media/bird_fly10.a9ef3ff7.gif";